import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIntegrationAutomation: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-integration-automation", jiraSpaEntry: "async-jira-eoc-integration-automation" */ '@jira/eoc__integration-automation/src/index.tsx'
	).then((module) => module.IntegrationAutomation),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIntegrationDetail: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-integration-automation-integration-detail", jiraSpaEntry: "async-jira-eoc-integration-automation-integration-detail" */ '@jira/eoc__integration-automation/src/index.tsx'
	).then((module) => module.IntegrationDetail),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIntegrationCreate: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-integration-automation-integration-create", jiraSpaEntry: "async-jira-eoc-integration-automation-integration-create" */ '@jira/eoc__integration-automation/src/index.tsx'
	).then((module) => module.IntegrationCreate),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIntegrationList: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-integration-automation-integration-list", jiraSpaEntry: "async-jira-eoc-integration-automation-integration-list" */ '@jira/eoc__integration-automation/src/index.tsx'
	).then((module) => module.IntegrationList),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIntegrationLog: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-integration-automation-integration-log", jiraSpaEntry: "async-jira-eoc-integration-automation-integration-log" */ '@jira/eoc__integration-automation/src/index.tsx'
	).then((module) => module.IntegrationLog),
);
